import { css } from '@emotion/css';

// eslint-disable-next-line import/prefer-default-export
export const dropdownLabel = css`
  flex: 1 0 40% !important;
`;
